import React, { useEffect, useState } from "react";
import classes from "./ProfileForm.module.css";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Button,
  Stack,
  TextField,
  InputLabel,
  MenuItem,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import BottomToolbar from "../UI/BottomToolbar";
import { ROLE } from "../../data/dummy-data";
import useUserProfileStore from "../../store/zustandStore/profile.Zs";

const ProfileForm = (props) => {
  const location = useLocation();
  const { getUserByIdZs, userIdZs, updateUserByIdZs } = useUserProfileStore();

  const user = useSelector((state) => state.auth.user);
  const [userState, setUserState] = useState(userIdZs);

  const profilData =
    user?.role === "ROLE_ADMIN" ? location?.state?.userCompany : userIdZs;

  // name;
  // email;
  // role;
  // reportingUnitId;

  const operatorFields = [
    {
      label: "E-mail",
      name: "email",
      value: "",
      required: true,
      type: "email",
      helperText: "E-mail është i detyruar",
      errorValue: false,
      disabled: false,
    },

    {
      label: "Roli",
      name: "role",
      value: "",
      required: true,
      type: "list",
      helperText: "Roli është i detyruar",
      options: ROLE,
      errorValue: false,
      disabled: true,
    },
  ];

  const [dataValuesTest, setDataValuesTest] = React.useState(operatorFields);

  const [dataValues, setDataValues] = React.useState({
    username: "",
    password: "",
    email: "",
    id: "",
    name: "",
  });

  useEffect(() => {
    if (!userIdZs) return;

    const ourNextValuesList = [...dataValuesTest];
    dataValuesTest?.map((item) => {
      const currentValueList = ourNextValuesList.filter((item) => {
        item.value = profilData[item.name];

        return item;
      });
    });

    setDataValues(userIdZs);
  }, [userIdZs]);

  useEffect(() => {
    const fetchData = async () => {
      await getUserByIdZs(user?.id); // Fetch chapter data
    };

    fetchData(); // Call the fetch function
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Lejo ndryshim vetëm për email
    if (name !== "email") return;

    const updatedFields = dataValuesTest.map((item) => {
      if (item.name === "email") {
        const newValue = type === "checkbox" ? checked : value;

        return {
          ...item,
          value: newValue,
          errorValue: item.required && newValue === "",
        };
      }
      return item;
    });

    setDataValuesTest(updatedFields);

    setDataValues((prev) => ({
      ...prev,
      email: value,
    }));
  };

  const saveForm = (e) => {
    var isError = false;

    const ourNextValuesList = [...dataValuesTest];
    const currentValueList = ourNextValuesList.filter((item) => {
      if (item.value === "" && item.required === true) {
        item.errorValue = true;
        isError = true;
      } else {
        item.errorValue = false;
      }
      return item;
    });

    setDataValuesTest(currentValueList); // here update errorValue of

    const { email, ...userProfileData } = userIdZs;

    const dataVlauesEnd = {
      email: dataValues.email,
      ...userProfileData,
    };

    if (isError) {
      console.log("Error Message");
    } else {
      e.preventDefault();
      updateUserByIdZs(dataVlauesEnd);
    }
  };

  return (
    <>
      <form className={classes.form}>
        <Typography
          sx={{ textAlign: "left", marginBottom: "30px" }}
          variant="h4"
        >
          {dataValues.name}
        </Typography>
        <section>
          <div style={{ marginTop: "0px" }}>
            <div>
              <Box sx={{ flexGrow: 1 }}>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    md={4}
                    key="username"
                    component="div"
                  >
                    <InputField
                      label="Username"
                      name={profilData?.username ?? userState?.username}
                      type="text"
                      value={profilData?.username ?? userState?.username}
                      disabled
                    ></InputField>
                  </Grid>
                  {dataValuesTest?.map((item) => {
                    return (
                      <Grid
                        item
                        xs={8}
                        sm={8}
                        md={item.type === "multiSelect" ? 12 : 4}
                        key={item?.label}
                        component="div"
                      >
                        <InputField
                          label={item?.label}
                          required={item?.required}
                          name={item?.name}
                          type={item?.type}
                          options={item?.options}
                          helperText={item?.helperText}
                          disabled={item?.disabled}
                          value={item?.value}
                          errorValue={item?.errorValue}
                          highliteInput={item?.highliteInput}
                          onChange={handleChange}
                        ></InputField>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </div>
            <BottomToolbar>
              <Button
                variant="contained"
                sx={{
                  width: "200px",
                  height: "52px",
                  backgroundColor: "primary.dark",
                }}
                onClick={saveForm}
              >
                Ruaj
              </Button>
            </BottomToolbar>
          </div>
        </section>
      </form>
    </>
  );
};

export const InputField = (props) => {
  return (
    <Stack spacing={1} sx={{ height: "100%" }}>
      <InputLabel
        sx={{
          fontFamily: "Basier Circle",
          fontSize: "18px",
          color: "#091B3D",
          lineHeight: "22px",
        }}
        required={props?.required}
      >
        {props?.label}
      </InputLabel>

      <div
        style={{
          margin: "auto 0 0 0",
          width: "100%",
        }}
      >
        <TextField
          select={props?.type === "list"}
          name={props?.name}
          autoComplete="off"
          id={props?.name}
          variant="outlined"
          required={props?.required}
          error={props?.errorValue}
          value={props?.value}
          onChange={props?.onChange}
          type={props?.type}
          helperText={props?.errorValue ? props?.helperText : null}
          sx={{
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
              height: "50px",
              textAlign: "left",
              ...(props?.highliteInput && { backgroundColor: "#feffe8" }),
            },
            "& .MuiInputBase-input.MuiOutlinedInput-input": {
              padding: "12px 14px",

              // ...(props?.highliteInput && { backgroundColor: "red" }),
            },
            width: "100%",
          }}
          disabled={props?.disabled}
        >
          {props?.type === "list" &&
            props?.options?.map((option) => (
              <MenuItem key={option?.value} value={option?.value}>
                {option?.label}
              </MenuItem>
            ))}
        </TextField>
      </div>
    </Stack>
  );
};

export default ProfileForm;
